import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { SeasonWorldLandingComponent } from './season-world-landing.component';
import { VersionService } from '../version.service';

@Injectable()
export class ShowSeasonWorldLandingService {
    dialogRef: MatDialogRef<SeasonWorldLandingComponent>;

    constructor(
        private _dialog: MatDialog,
        private _versionSrv: VersionService
    ) {
    }

    show() {
        if (this.dialogRef) {
            return;
        }

        this.dialogRef = this._dialog.open(SeasonWorldLandingComponent, {
            panelClass: ['--season-world-landing'],
            backdropClass: '--season-world-landing-backdrop',
        });

        this.dialogRef.componentInstance.close.subscribe(() => {
            localStorage.setItem(`season${this._versionSrv.data.currentSeason || ''}WorldLandingViewed`, Date.now().toString());

            this.dialogRef.close();
        });

        this.dialogRef.afterClosed().subscribe(() => {
            this.dialogRef = null;
        });
    }

    available(): boolean {
        const now = new Date() .getTime();

        if (!window.CONFIG.SEASON_START_TIME || !(window.CONFIG.SEASON_START_TIME > now)) {
            return false;
        }

        if(!window.CONFIG.SEASON_WORLD_LANDING || (window.CONFIG.SEASON_WORLD_LANDING > now)) {
            return false;
        }

        try {
            const firstVisit = parseInt(localStorage.getItem('firstVisit'), 10)

            if (!isFinite(firstVisit)) {
                return false;
            }

            if (firstVisit && firstVisit > window.CONFIG.SEASON_WORLD_LANDING) {
                return false;
            }
        } catch (err) {
            // Noop.
        }

        try {
            const seasonWorldLandingViewed = parseInt(localStorage.getItem(`season${this._versionSrv.data.currentSeason || ''}WorldLandingViewed`), 10);
            
            if (isFinite(seasonWorldLandingViewed) && seasonWorldLandingViewed < window.CONFIG.SEASON_WORLD_LANDING) {
                return true;
            }

            if (isFinite(seasonWorldLandingViewed)) {
                return false;
            }
        } catch (err) {
            // Noop.
        }

        return true;
    }
}
